import React from 'react';
import { useNavigate } from "react-router-dom";
import styles from '../assets/styles/Doc.module.scss';
import PublicHeader from '../components/PublicHeader';

import { useScrollToTop } from '../hooks/useScrollToTop';

const HomePage: React.FC = () => {
  useScrollToTop();
  const navigate = useNavigate();

  const handleUserAccess = (path: "login" | "register") => {
    navigate(`/${path}`);
  };

  return (
    <>
      <PublicHeader />
      <div className={styles.container}>
        <div className={styles.docContent}>
          <h1>プライバシーポリシー</h1>
          <p className={styles.mainTxt}>
            株式会社Inovis（以下「当社」といいます）は、当社が提供する「AIBEX」（以下「本サービス」といいます）における個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます）を定めます。<br />
            当社は、利用者の個人情報を保護し、安心して本サービスをご利用いただけるよう努めます。
          </p>
          <h2>第1条（適用範囲）</h2>
          <p>
            本ポリシーは、当社が本サービスおよび当社ウェブサイト（以下「本サイト」）を通じて取得する一切の個人情報・利用情報の取扱いに適用されます。<br />
            当社が委託を受けて処理する顧客データおよび第三者から提供を受ける情報についても、同様に本ポリシーに従って取り扱います。
          </p>

          <h2>第2条（取得する情報の種類）</h2>
          <p>当社は、以下の情報を取得する場合があります。</p>
          <ul className={styles.list1}>
            <li>
              利用者から直接提供される情報
              <p>氏名、会社名、部署名、役職、住所、電話番号、メールアドレス、広告アカウント情報、請求先情報、その他申込・問い合わせフォームに記載された情報。</p>
            </li>
            <li>
              <p>本サービスの利用に伴い自動的に取得する情報</p>
              <ul className={styles.list2}>
                <li>IPアドレス、クッキー情報、端末識別情報、ブラウザ情報、アクセス日時、利用履歴、操作ログ等</li>
                <li>広告配信やレポート生成のために利用される分析データ、API連携による媒体データ（例：Google、Meta、LINE等の広告アカウント情報）</li>
              </ul>
            </li>
            <li>
              外部サービス連携により取得する情報
              <p>利用者が本サービスと連携を許可した外部サービス（Googleアカウント、Meta広告マネージャー、LINE広告アカウントなど）から取得する広告運用データ、コンバージョン情報、キャンペーン設定情報など。</p>
            </li>
          </ul>

          <h2>第3条（利用目的）</h2>
          <p>
            当社は、取得した個人情報を以下の目的で利用します。
          </p>
          <ul className={styles.list1}>
            <li>本サービスの提供・運用・保守・改善のため</li>
            <li>利用申込、本人確認、契約締結、請求・支払処理のため</li>
            <li>お問い合わせ・サポート対応、各種連絡のため</li>
            <li>本サービスに関するお知らせ、キャンペーン、セミナー等の案内のため</li>
            <li>新機能・新サービスの開発および品質向上のため</li>
            <li>利用状況の分析、統計データの作成、マーケティング施策の最適化のため</li>
            <li>不正アクセスや利用規約違反などの防止および対応のため</li>
            <li>上記に付随・関連する目的のため</li>
          </ul>

          <h2>第4条（第三者提供）</h2>
          <p>当社は、次の場合を除き、取得した個人情報を第三者に提供しません。</p>
          <ul className={styles.list1}>
            <li>利用者の同意がある場合</li>
            <li>法令に基づく場合</li>
            <li>人の生命・身体・財産の保護のために必要がある場合で、本人の同意を得ることが困難な場合</li>
            <li>業務委託先に対し、委託業務の遂行に必要な範囲で提供する場合（例：サーバー保守、請求管理、カスタマーサポート）</li>
            <li>合併、事業譲渡その他の事業承継に伴って個人情報が提供される場合</li>
          </ul>

          <h2>第5条（業務委託）</h2>
          <p>
            当社は、サービス運営上必要な範囲で、個人情報の取扱いを外部業者に委託する場合があります。<br />
            この場合、当社は委託先を適切に監督し、機密保持契約を締結のうえ、個人情報の安全管理が図られるよう努めます。
          </p>

          <h2>第6条（個人情報の管理）</h2>
          <p>
            当社は、利用者の個人情報を正確かつ最新の状態に保ち、不正アクセス、紛失、破壊、改ざん、漏洩等を防止するため、合理的な安全対策を講じます。<br />
            当社は、従業員および委託先に対し、個人情報の適正な取扱いについて教育・指導を行います。
          </p>

          <h2>第7条（クッキーおよびアクセス解析ツール）</h2>
          <p>
            当社は、ウェブサイト利用状況の分析およびサービス改善のため、クッキー（Cookie）およびアクセス解析ツール（Google Analytics等）を使用することがあります。<br />
            利用者は、ブラウザ設定によりクッキーの受け入れを拒否することができますが、その場合、一部機能が利用できない可能性があります。
          </p>

          <h2>第8条（外部リンクおよび第三者サービス）</h2>
          <p>
            当社ウェブサイトからリンクする外部サイト・サービスは、当社が管理するものではありません。<br />
            これらのサイトにおける個人情報の取扱いについて、当社は一切の責任を負いません。
          </p>

          <h2>第9条（個人情報の開示・訂正・利用停止等）</h2>
          <p>
            利用者は、当社が保有する自己の個人情報について、開示・訂正・削除・利用停止等を請求することができます。<br />
            当社は、法令に基づき、合理的な範囲でこれに対応します。
          </p>

          <h2>第10条（匿名加工情報および統計情報の取扱い）</h2>
          <p>
            当社は、個人を特定できない形式に加工した統計データを作成し、マーケティングやサービス改善に利用・公開することがあります。<br />
            このデータは個人を特定できるものではありません。
          </p>

          <h2>第11条（法令遵守および継続的改善）</h2>
          <p>
            当社は、個人情報保護法および関連法令を遵守し、社内規程を適宜見直すことで、個人情報保護体制の継続的改善を行います。
          </p>

          <h2>第12条（お問い合わせ窓口）</h2>
          <p>
            本ポリシーまたは個人情報の取扱いに関するお問い合わせは、下記窓口までご連絡ください。
          </p>
          <br />
          <p>
            株式会社Inovis AIBEX運営事務局<br />
            所在地：〒150-0043 東京都渋谷区道玄坂1丁目21番1号<br />
            E-mail：info@inovis.co.jp<br />
            （受付時間：平日10:00〜18:00）
          </p>

          <h2>第13条（改定）</h2>
          <p>
            当社は、必要に応じて本ポリシーを変更することがあります。<br />
            変更後の内容は、本サイト上に掲示した時点で効力を生じるものとします。
          </p>
          <br />
          <p>
            制定日：2025年10月28日<br />
            改定日：2025年10月28日（初版）
          </p>
        </div>
      </div>
    </>
  );
};

export default HomePage;
